import React from 'react';
import { useTranslation } from 'react-i18next';
import DOMPurify from 'dompurify';
import { createStyles, makeStyles, useMediaQuery } from '@material-ui/core';
import {
    Typography,
    Variant,
    Police,
    Button,
    ButtonVariant,
    ContainerMui,
    DateText
} from '../../styles';

const useStyles = makeStyles(() =>
    createStyles({
        description: {
            maxWidth: '400px'
        },
        titre: {
            fontSize: '24px !important'
        }
    })
);

export interface IResumeDateProps {
    dateProchainPaiement: string;
    dateDernierPaiement: string;
    isEditButtonDisplayed: boolean;
    shouldBeDisplayed: boolean;
    onModifiedClick: () => void;
}

export const ResumeDate: React.FC<IResumeDateProps> = ({
    dateProchainPaiement,
    dateDernierPaiement,
    isEditButtonDisplayed,
    shouldBeDisplayed,
    onModifiedClick
}) => {
    const [t] = useTranslation(['ResumeDate']);
    const isMobile = useMediaQuery('(max-width:640px)');
    const classes = useStyles();
    const oldDate = new Date(dateDernierPaiement);

    return (
        <>
            {shouldBeDisplayed && (
                <ContainerMui
                    padding={isMobile ? '1rem' : '1.5rem'}
                    spacerDistance={6}
                    spacerDistanceMobile={5}
                >
                    <Typography
                        variant={Variant.h3}
                        police={Police.bold}
                        className={classes.titre}
                        marginBottom="1rem"
                    >
                        {t('resumeDateTitle')}
                    </Typography>
                    <Typography
                        variant={Variant.p}
                        marginBottom="1rem"
                        className={classes.description}
                    >
                        <DateText
                            translationKey="ResumeDate:resumeDateDisclaimerText"
                            date={oldDate}
                        >
                            {{ date: oldDate }}
                        </DateText>
                    </Typography>
                    <Typography variant={Variant.p} marginBottom="0.25rem">
                        {t('resumeDatePremierPaiementTitle')}
                    </Typography>
                    <Typography variant={Variant.p} police={Police.bold}>
                        <span
                            dangerouslySetInnerHTML={{
                                __html: DOMPurify.sanitize(
                                    t('Date:fullCapitalizedFirstLetter', {
                                        value: dateProchainPaiement
                                        // value: '20210201'
                                    })
                                )
                            }}
                        />
                    </Typography>
                    {/* Ne pas afficher si MARTINE ( page validation ou choix 1er coemprunteur ) */}
                    {isEditButtonDisplayed && (
                        <Button
                            id={'QA_test_validation_date_modifier'}
                            variant={ButtonVariant.compact}
                            dataCy="qa-button-date-modifier"
                            dataTestId={'bouton_modifier_date_paiement'}
                            onClick={onModifiedClick}
                            srOnlySuffix={
                                t('resumeChangeButton') +
                                ' ' +
                                t('resumeChangeButtonLabelHorsEcran')
                            }
                        >
                            {t('resumeChangeButton')}
                        </Button>
                    )}
                </ContainerMui>
            )}
        </>
    );
};
